import CTABody from "@components/CTABody";
import Section from "@components/Section";
import SimpleAccordion from "@components/SimpleAccordion";
import SimpleRichText from "@components/SimpleRichText";
import { getSerifClass, isInverted } from "@components/utilities";
import { Title } from "@justhome/react-ui";
import {
  ComponentBlocksButton,
  ComponentSectionsCtaWithFaqV2,
} from "@lib/generated/graphql";
import { mapFaqs } from "@lib/utilities";
import { FC, useMemo } from "react";

type FaqItem = {
  answer: string;
  question: string;
  button?: ComponentBlocksButton;
};

const FAQList: FC<{
  faqs: Array<FaqItem>;
  isOpen: boolean;
}> = ({ faqs, isOpen }) => {
  return (
    <>
      {faqs.map((faq, index) => (
        <SimpleAccordion
          initiallyOpen={isOpen}
          key={faq.question}
          title={faq.question}
          last={index === faqs.length - 1}
        >
          <SimpleRichText className="text-body-2">{faq.answer}</SimpleRichText>
        </SimpleAccordion>
      ))}
    </>
  );
};

const CtaWithAccordion: FC<{
  data: ComponentSectionsCtaWithFaqV2;
  index: number;
}> = ({ data, index }) => {
  const { title, subTitle, button, cardButton, background, faqs, faqsOpen } =
    data;

  const list: Array<FaqItem> | undefined = useMemo(() => {
    return mapFaqs(faqs);
  }, [faqs]);

  const inverted = isInverted(background);
  return (
    <Section
      index={index}
      section={data}
      className="my-3xl m:my-[160px] grid grid-cols-1 m:grid-cols-12 gap rounded-m grid-flow-row-dense"
    >
      <div className="m:col-span-4">
        <Title
          inverted={inverted}
          serifClass={getSerifClass(background)}
          className="text-d3 whitespace-pre-line"
        >
          {title}
        </Title>
        <CTABody.SubTitle inverted={inverted}>{subTitle}</CTABody.SubTitle>
        <CTABody.Action
          className="hidden m:block"
          CTA={{
            button,
            cardButton,
          }}
        />
      </div>
      <div className="m:col-span-8 m:row-span-2 m:col-start-5 m:row-start-1">
        <FAQList faqs={list} isOpen={faqsOpen} />
        <CTABody.Action
          className="m:hidden mt-2xs"
          CTA={{
            button,
            cardButton,
          }}
        />
      </div>
    </Section>
  );
};

export default CtaWithAccordion;
